import { render, staticRenderFns } from "./SelectorsPage.vue?vue&type=template&id=65808cf6&scoped=true&"
import script from "./SelectorsPage.vue?vue&type=script&lang=js&"
export * from "./SelectorsPage.vue?vue&type=script&lang=js&"
import style0 from "./SelectorsPage.vue?vue&type=style&index=0&id=65808cf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65808cf6",
  null
  
)

export default component.exports